import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../../../context/ThemeContext';

const GradientCard = ({ title, value, icon, gradient, children }) => {
  const { isDarkMode } = useTheme();

  return (
    <motion.div
      whileHover={{ scale: 1.05 }}
      className={`relative overflow-hidden rounded-3xl ${isDarkMode ? 'bg-gray-800/80' : 'bg-white/80'} backdrop-blur-sm p-6 border ${isDarkMode ? 'border-gray-700/50' : 'border-gray-200/50'} shadow-sm`}
    >
      <div className={`absolute top-0 right-0 w-32 h-32 -mt-16 -mr-16 bg-gradient-to-r ${isDarkMode ? 'from-orange-900 to-orange-800' : 'from-orange-500 to-orange-600'} rounded-full opacity-10`}></div>

      <div className="relative z-10">
        <div className="flex items-center justify-between mb-4">
          <h3 className={`text-lg font-semibold ${isDarkMode ? 'text-gray-100' : 'text-gray-900'}`}>{title}</h3>
          <div className={`p-2 rounded-2xl bg-gradient-to-r ${gradient} text-white`}>
            {icon}
          </div>
        </div>

        {value && (
          <div className={`text-3xl font-bold ${isDarkMode ? 'text-gray-100' : 'text-gray-900'} mb-2`}>
            {value}
          </div>
        )}

        {children}
      </div>
    </motion.div>
  );
};

export default GradientCard;